import type { FixedCharge } from '#api/shared/@types/generated/backend/graphql-schema-types'

import type { Config, PriceList } from '../@types/editor'

export type EditorWager = { id: string; value: number }

const byValueAscending = (a: EditorWager, b: EditorWager) => a.value - b.value

const isFixedCharge = (charge: unknown): charge is FixedCharge =>
  (charge as FixedCharge)?.value !== undefined

const without =
  (values: number[]) =>
  ({ value }: EditorWager) =>
    !values.includes(value)

export const getPreparedWagers = (config: Config, priceList: PriceList): EditorWager[] => {
  const fixedCharges = priceList.charges.filter(isFixedCharge)

  return config.stakes
    .map(({ price }) => ({
      id: price,
      value: fixedCharges.find((charge) => charge.id === price)?.value.value ?? 0,
    }))
    .sort(byValueAscending)
}

export const getWagerMarker = (wagers: EditorWager[]) => {
  const max = getMaxWagerValue(wagers)
  const min = getMinWagerValue(wagers)

  const toMarker = ({ value }: EditorWager, index: number) => [
    (100 / (wagers.length - 1)) * (index + 1),
    value,
  ]

  return {
    snap: true,
    steps: Object.fromEntries(wagers.filter(without([max, min])).map(toMarker)),
  }
}

export const getMaxWagerValue = (wagers: EditorWager[]) => wagers.at(-1)?.value ?? 1

export const getMinWagerValue = (wagers: EditorWager[]) => wagers.at(0)?.value ?? 0
